import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { PromotionScheduleDetailContainer } from '../../containers/promotion/PromotionScheduleDetailContainer';
import { PROMOTION_SCHEDULE_DETAIL_PAGE_NAME } from '../../views/promotion/schedule/constants';

/**
 * 프로모션 상세 페이지 (AMZUWEB-682).
 *
 * 링크로 주고받을 수 있는 한 건의 전부. R2 기획안·R5 성과가 탭으로 붙을 자리다.
 */
const PromotionScheduleDetail = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={PROMOTION_SCHEDULE_DETAIL_PAGE_NAME}>
      <PromotionScheduleDetailContainer />
    </PageTemplate>
  );
};

export default PromotionScheduleDetail;
